import api from './api';
import { CallLog, CallStatistics } from '../types';

export interface CreateCallLogData {
  entity_type: 'lead' | 'customer' | 'tender';
  entity_id: number;
  lead_assignment_id?: number | null;
  tender_assignment_id?: number | null;
  call_date: string;
  call_time?: string;
  call_duration?: number;
  call_status_id?: number;
  call_outcome?: string;
  notes?: string;
  next_call_date?: string;
  next_call_notes?: string;
  call_type?: 'inbound' | 'outbound';
  scheduled_call_id?: number;
}

export interface UpdateCallLogData {
  call_date?: string;
  call_time?: string;
  call_duration?: number;
  call_status_id?: number;
  call_outcome?: string;
  notes?: string;
  next_call_date?: string;
  next_call_notes?: string;
  call_type?: 'inbound' | 'outbound';
  is_completed?: boolean;
  is_missed?: boolean;
}

export interface CallLogFilters {
  entity_type?: 'lead' | 'customer' | 'tender';
  entity_id?: number;
  called_by?: number;
  call_date?: string;
  call_status_id?: number;
}

export const callLogService = {
  getAll: async (filters?: CallLogFilters): Promise<CallLog[]> => {
    const response = await api.get('/api/call-logs', { params: filters });
    return response.data;
  },

  getByEntity: async (
    entityType: 'lead' | 'customer' | 'tender',
    entityId: number,
    params?: { called_by?: number; all?: boolean }
  ): Promise<CallLog[]> => {
    const response = await api.get(`/api/call-logs/entity/${entityType}/${entityId}`, { params });
    return response.data;
  },

  getLatestByEntity: async (
    entityType: 'lead' | 'customer' | 'tender',
    entityId: number,
    params?: { exclude_id?: number }
  ): Promise<CallLog | null> => {
    const response = await api.get(`/api/call-logs/entity/${entityType}/${entityId}/latest`, { params });
    return response.data ?? null;
  },

  getById: async (id: number): Promise<CallLog> => {
    const response = await api.get(`/api/call-logs/${id}`);
    return response.data;
  },

  create: async (data: CreateCallLogData): Promise<CallLog> => {
    const response = await api.post('/api/call-logs', data);
    return response.data;
  },

  update: async (id: number, data: UpdateCallLogData): Promise<void> => {
    await api.put(`/api/call-logs/${id}`, data);
  },

  delete: async (id: number): Promise<void> => {
    await api.delete(`/api/call-logs/${id}`);
  },

  getStatistics: async (entityType: 'lead' | 'customer' | 'tender', entityId: number): Promise<CallStatistics> => {
    const response = await api.get(`/api/call-logs/statistics/${entityType}/${entityId}`);
    return response.data;
  },

  getTodayCalls: async (): Promise<CallLog[]> => {
    const response = await api.get('/api/call-logs/today');
    return response.data;
  },

  getUpcomingCalls: async (days: number = 7): Promise<CallLog[]> => {
    const response = await api.get('/api/call-logs/upcoming', { params: { days } });
    return response.data;
  },
};

